import { Profile } from "../components/profile/profile";

export function ProfilePage() {
  return <Profile />;
}
